import {Toaster} from 'react-hot-toast';

export function Toasts() {
  return (
    <span>
      <Toaster toastOptions={{position: 'top-left'}} />
    </span>
  );
}
